// @flow
import React, { type Element } from 'react';
import UserEdit from './UserEdit';

const UserList = (): Element<*> => <UserEdit />;

export default UserList;
